import {
  type LabelData,
  getPredictionMarketLabelQueries,
} from "@roman/shared/hooks/PredictionMarket/usePredictionMarketLabels";
import { cn } from "@roman/shared/utils";

interface LabelSelectorProps {
  labels: LabelData[];
  selectedLabel: LabelData;
  onLabelSelect: (label: LabelData) => void;
}

export const LabelSelector = ({ labels, selectedLabel, onLabelSelect }: LabelSelectorProps) => {
  return (
    <div className="overflow-hidden relative">
      <div className="flex w-full h-[52px] bg-white overflow-x-scroll hide-scrollbar">
        {labels.map((label) => {
          const { displayText } = getPredictionMarketLabelQueries(label);
          const isSelectedLabel = selectedLabel === label;

          return (
            <div key={label} className="flex-shrink-0 flex border-solid relative">
              <div
                className={cn(
                  "flex items-center bg-white hover:cursor-pointer justify-center text-base md:text-sm lg:text-sm xl:text-base px-4 min-w-[64px]",
                  isSelectedLabel ? "text-primary font-bold" : "text-gray",
                )}
                onClick={() => onLabelSelect(label)}
              >
                <p className="text-center font-semibold text-sm">
                  {displayText.split("\n").flatMap((line) => (
                    <span key={line}>
                      {line === "人気" ? "🔥人気" : line}
                      <wbr />
                    </span>
                  ))}
                </p>
              </div>
              <div
                className={cn(
                  "absolute bottom-0 left-0 right-0 h-0.5 px-3  opacity-0 z-10",
                  isSelectedLabel && "opacity-100",
                )}
              >
                <span className="block h-full bg-primary z-50" />
              </div>
            </div>
          );
        })}
      </div>

      <div className={cn("absolute bottom-0 left-0 right-0 h-0.5 bg-gray z-9 w-full")} />
    </div>
  );
};
